export default "<div class=\"cart-tile-banner\"\n     [innerHTML]=\"data.content\"\n     [ngStyle]=\"{'background-color': data.backgroundColor}\"\n>\n</div>\n";